import { createTheme, type CSSVariablesResolver } from '@mantine/core';

/**
 * Niebieski kolor marki #00ADEE (odcień 6 = przyciski, aktywna pozycja menu) – próba z 2026‑09‑29.
 * Poprzedni, morski: ['#e7f6f6', '#cdebeb', '#9dd7d7', '#69c2c2', '#3fb0b0', '#22a2a2', '#0b8a8a', '#08797a', '#056566', '#004f50']
 */
const brand = ['#e5f7fd', '#ccf0fb', '#99e0f7', '#66d0f4', '#33c0f0', '#14b5ee', '#00adee', '#0092c9', '#0077a4', '#005c7f'] as const;

/** Motyw Mantine. Kolory typów zajęć przychodzą z bazy (US-304), więc tu tylko baza wyglądu. */
export const theme = createTheme({
  colors: { brand: [...brand] },
  primaryColor: 'brand',
  primaryShade: 6,
  defaultRadius: 'md',
  fontFamily: 'system-ui, -apple-system, "Segoe UI", Roboto, sans-serif',
  headings: { fontWeight: '800' },
});

/** Ciepłe, kremowe tło stron; panel boczny odrobinę ciemniejszy (`--koderek-navbar-bg`). */
export const cssVariablesResolver: CSSVariablesResolver = () => ({
  variables: {},
  light: { '--mantine-color-body': '#faf8f3', '--koderek-navbar-bg': '#f4f0e4' },
  dark: { '--koderek-navbar-bg': 'var(--mantine-color-dark-8)' },
});
